import React, { useState, useEffect } from "react";
import { Youtube } from "react-feather";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import VideoBox from "app/shared/components/ReusableComponents/VideoPlayer/container";
import img from "assets/images/no-image2.jpg";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import AIModal from "./aiModal";
import { Modal } from "react-bootstrap";
import usePermittedRoute from "app/hook/usePermittedRoute";
import { AI } from "app/shared/constants/ModuleNames";
import { useTranslation } from "react-i18next";
import FsLightbox from "fslightbox-react";
import { Play } from "react-feather";

export const CarouselComponent = ({
  wrapperClassName,
  carouselProps,
  items = [],
  isExtendView = false,
  displayEmptyIndicator = true,
}) => {
  const [aiData, setAiData] = useState({});
  const [isCommunicationNotification, setCommunicationNotification] =
    React.useState(false);
  const [_checkPermittedRoute] = usePermittedRoute();
  const [lightboxactive, setLightboxactive] = useState(false);
  const [evidencelightbox, setEvidencelightbox] = useState([""]);
  const [evidencelightboxType, setEvidencelightboxType] = useState(["image"]);
  const [fsToggler, setfsToggler] = useState(false);

  const { t } = useTranslation(["util"]);
  const aiModal = (element) => {
    setAiData(element);
    setCommunicationNotification(true);
  };

  const __renderAiOverlay = (aiStatus, element) => {
    if (!_checkPermittedRoute(AI)) return;

    if (aiStatus == "1") {
      return (
        <div
          onClick={() => aiModal(element)}
          className="ai-overlay-verify"
          style={{ cursor: "pointer" }}
        >
          {t("ai")} <IoMdCheckmarkCircleOutline />
        </div>
      );
    } else if (aiStatus == undefined) {
      return;
    } else {
      console.log("render called");
      return (
        <div
          onClick={() => aiModal(element)}
          className="ai-overlay-verify"
          style={{ cursor: "pointer" }}
        >
          {t("ai")}
          <IoMdCheckmarkCircleOutline />
        </div>
      );
      //  <div className="ai-overlay-unverify"
      //  onClick={() => aiModal(element)}>
      //  AI <RxCrossCircled /></div>;
    }
  };

  const __renderCarouselContent = (element, items) => {
    const { url, contentType, aiStatus, aiImage, aiResponse } = element ?? {};

    if (contentType === "image") {
      return (
        <div onClick={() => handleLightBox(items)}>
          <img src={url} alt={t("thumbnail")} />
          {__renderAiOverlay(aiStatus, element)}
        </div>
      );
    } else if (contentType === "video") {
      return (
        <div
          onClick={() => handleLightBox(items)}
          style={{ position: "relative", cursor: "pointer" }}
        >
          <video
            src={url}
            preload="metadata"
            muted
            style={{
              width: "100%",
              minHeight: "8rem",
              maxHeight: "14rem",
              objectFit: "cover",
              display: "block",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 48,
              height: 48,
              borderRadius: "50%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2,
              pointerEvents: "none", // click passes through to wrapping div
            }}
          >
            <Play color="#fff" size={20} fill="#fff" />
          </div>
          {__renderAiOverlay(aiStatus, element)}
        </div>
      );
    }
  };
  const arrowStyles = {
    position: "absolute",
    zIndex: 2,
    top: "calc(50% - 15px)",
    width: 30,
    height: 30,
    cursor: "pointer",
    color: "#000",
  };

  const indicatorStyles = {
    background: "#D9D9D9",
    borderRadius: "13px",
    width: "1.5vw",
    cursor: "pointer",
    height: 8,
    display: "inline-block",
    margin: "0 8px",
  };
  const customRenderItem = (item, props) => (
    <item.type {...item.props} {...props} />
  );
  const customRenderThumb = (children) =>
    children.map((item) => {
      if (item.props.contentType === "image") {
        return <img src={item.props.itemUrl} />;
      } else if (item.props.contentType === "video") {
        return (
          <Youtube
            style={{
              display: "block",
              width: "inherit",
              height: "inherit",
              padding: "0px 10px",
            }}
          />
        );
      }
    });

  const handleLightBox = (list) => {
    const validLinks = list
      .filter((item) => {
        const format = item.contentType?.toLowerCase();
        return (
          format === "img" ||
          format.includes("image") ||
          format.includes("video")
        );
      })
      .map((item) => item.url);

    const types = list
      .filter((item) => {
        const format = item.contentType?.toLowerCase();
        return (
          format === "img" ||
          format.includes("image") ||
          format.includes("video")
        );
      })
      .map((item) => {
        const format = item.contentType?.toLowerCase();
        return format.includes("video") ? "video" : "image";
      });

    setEvidencelightbox(validLinks);
    setEvidencelightboxType(types);
    // fsToggler is now flipped in the effect below, AFTER the remount commits
  };

  useEffect(() => {
    // skip the initial mount (placeholder state)
    if (evidencelightbox.length === 1 && evidencelightbox[0] === "") return;
    setfsToggler((prev) => !prev);
  }, [evidencelightbox]);

  return (
    <div
      className={`${wrapperClassName} ${!isExtendView ? "remove-thumbnail" : ""} ${items.length === 1 ? "remove-indicator" : ""}`}
    >
      {items.length ? (
        <Carousel
          {...carouselProps}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              // <ChevronLeft title={label} onClick={onClickHandler} style={{ ...arrowStyles, left: 15 }} />
              <></>
            )
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <></>
              // <ChevronRight onClick={onClickHandler} title={label} style={{ ...arrowStyles, right: 15 }} />
            )
          }
          renderIndicator={(onClickHandler, isSelected, index, label) => {
            if (isSelected) {
              return (
                <li
                  style={{ ...indicatorStyles, background: "#000" }}
                  aria-label={`Selected: ${label} ${index + 1}`}
                  title={`Selected: ${label} ${index + 1}`}
                />
              );
            }
            return (
              <li
                style={indicatorStyles}
                onClick={onClickHandler}
                onKeyDown={onClickHandler}
                value={index}
                key={index}
                role="button"
                tabIndex={0}
                title={`${label} ${index + 1}`}
                aria-label={`${label} ${index + 1}`}
              />
            );
          }}
          renderItem={customRenderItem}
          renderThumbs={customRenderThumb}
        >
          {items?.map((el, idx) => (
            <div key={idx} contentType={el.contentType} itemUrl={el.url}>
              {" "}
              {__renderCarouselContent(el, items)}{" "}
            </div>
          ))}
        </Carousel>
      ) : (
        <div>
          {displayEmptyIndicator ? (
            <img src={img} className="img-fluid" />
          ) : (
            <></>
          )}
        </div>
      )}
      <Modal
        show={isCommunicationNotification}
        onHide={() => setCommunicationNotification(false)}
        dialogclassname={aiData?.evidence?.imageUrl ? "modal-xl" : "modal"}
        closebutton
      >
        <AIModal
          aiData={aiData}
          handleClose={() => setCommunicationNotification(false)}
          type={"uauc"}
        />
      </Modal>
      {/* {!!lightboxactive && ( */}
      <FsLightbox
        key={evidencelightbox.join(",")}
        toggler={fsToggler}
        types={evidencelightboxType}
        disableLocalStorage={true}
        sources={evidencelightbox}
      />
      {/* )} */}
    </div>
  );
};
